// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSquareFullscreen = ({
  color = 'currentColor',
  size = 20
}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.8 2.8a1 1 0 0 0-1 1v8.4a1 1 0 0 0 1 1h8.4a1 1 0 0 0 1-1V3.8a1 1 0 0 0-1-1H3.8Zm-2.2 1a2.2 2.2 0 0 1 2.2-2.2h8.4a2.2 2.2 0 0 1 2.2 2.2v8.4a2.2 2.2 0 0 1-2.2 2.2H3.8a2.2 2.2 0 0 1-2.2-2.2V3.8Zm7.024 4.424-.4.4L6.05 10.8H7.4a.6.6 0 1 1 0 1.2H4.6a.598.598 0 0 1-.6-.6V8.6a.6.6 0 0 1 1.2 0v1.351l2.176-2.175.4-.4L9.952 5.2H8.6a.6.6 0 0 1 0-1.2h2.8a.598.598 0 0 1 .6.6v2.8a.6.6 0 0 1-1.2 0V6.049L8.624 8.224Z"
    />
  </svg>
)

export default SvgSquareFullscreen
